import {
  FascicoloTentativoObbligatorioConciliazione
} from '../../../../lavoro/fascicoloFormShared/models/tentativo-obbligatorio-conciliazione/fascicolo-tentativo-obbligatorio-conciliazione';
import {
  FormConciliazioneStragiudizialeComponent
} from '../../../../lavoro/fascicoloFormShared/form-conciliazione-stragiudiziale/form-conciliazione-stragiudiziale.component';
import {FascicoloRitoFornero} from '../../../../lavoro/fascicoloFormShared/models/rito-fornero/fascicolo-rito-fornero';
import {
  FascicoloConciliazioneStragiudiziale
} from '../../../../lavoro/fascicoloFormShared/models/conciliazione-stragiudiziale/fascicolo-conciliazione-stragiudiziale';
import {
  FormPrevidenzialeComponent
} from '../../../../lavoro/fascicoloFormShared/form-previdenziale/form-previdenziale.component';
import {
  FormConciliazioneStragiudizialeViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-conciliazione-stragiudiziale/view/form-conciliazione-stragiudiziale-view.component';
import {
  FormPrevidenzialeViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-previdenziale/view/form-previdenziale-view.component';
import {
  FormRitoForneroViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-rito-fornero/view/form-rito-fornero-view.component';
import {
  FascicoloPrevidenziale
} from '../../../../lavoro/fascicoloFormShared/models/previdenziale/fascicolo-previdenziale';
import {
  FormRitoForneroComponent
} from '../../../../lavoro/fascicoloFormShared/form-rito-fornero/form-rito-fornero.component';
import {
  FormTentativoObbligatorioConciliazioneComponent
} from '../../../../lavoro/fascicoloFormShared/form-tentativo-obbligatorio-conciliazione/form-tentativo-obbligatorio-conciliazione.component';
import {
  FormTentativoObbligatorioConciliazioneViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-tentativo-obbligatorio-conciliazione/view/form-tentativo-obbligatorio-conciliazione-view.component';
import {
  FormAmiantoViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-amianto/view/form-amianto-view.component';
import {FormAmiantoComponent} from '../../../../lavoro/fascicoloFormShared/form-amianto/form-amianto.component';
import {
  FormAmiantoGiudizialeViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-amianto-giudiziale/view/form-amianto-giudiziale-view.component';
import {
  FormAmiantoGiudizialeComponent
} from '../../../../lavoro/fascicoloFormShared/form-amianto-giudiziale/form-amianto-giudiziale.component';
import {
  FormAppelloViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-appello/view/form-appello-view.component';
import {FormAppelloComponent} from '../../../../lavoro/fascicoloFormShared/form-appello/form-appello.component';
import {FormArbitratoComponent} from '../../../../lavoro/fascicoloFormShared/form-arbitrato/form-arbitrato.component';
import {
  FormArbitratoViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-arbitrato/view/form-arbitrato-view.component';
import {
  FormAzioneMonitoriaViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-azione-monitoria/view/form-azione-monitoria-view.component';
import {
  FormAzioneMonitoriaComponent
} from '../../../../lavoro/fascicoloFormShared/form-azione-monitoria/form-azione-monitoria.component';
import {
  FormOpposizioneDecretoIngiuntivoViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-opposizione-decreto-ingiuntivo/view/form-opposizione-decreto-ingiuntivo-view.component';
import {
  FormOpposizioneDecretoIngiuntivoComponent
} from '../../../../lavoro/fascicoloFormShared/form-opposizione-decreto-ingiuntivo/form-opposizione-decreto-ingiuntivo.component';
import {
  FormRicorsoCassazioneViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-ricorso-cassazione/view/form-ricorso-cassazione-view.component';
import {
  FormRicorsoCassazioneComponent
} from '../../../../lavoro/fascicoloFormShared/form-ricorso-cassazione/form-ricorso-cassazione.component';
import {
  FormRicorsoLavoroViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-ricorso-lavoro/view/form-ricorso-lavoro-view.component';
import {
  FormRicorsoLavoroComponent
} from '../../../../lavoro/fascicoloFormShared/form-ricorso-lavoro/form-ricorso-lavoro.component';
import {
  FormRicorsoOpposizioneViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-ricorso-opposizione/view/form-ricorso-opposizione-view.component';
import {
  FormRicorsoOpposizioneComponent
} from '../../../../lavoro/fascicoloFormShared/form-ricorso-opposizione/form-ricorso-opposizione.component';
import {
  FormCautelareViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-cautelare/view/form-cautelare-view.component';
import {FormCautelareComponent} from '../../../../lavoro/fascicoloFormShared/form-cautelare/form-cautelare.component';
import {
  FormOrdinarioViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-ordinario/view/form-ordinario-view.component';
import {FormOrdinarioComponent} from '../../../../lavoro/fascicoloFormShared/form-ordinario/form-ordinario.component';
import {
  FormSpecialeViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-speciale/view/form-speciale-view.component';
import {FormSpecialeComponent} from '../../../../lavoro/fascicoloFormShared/form-speciale/form-speciale.component';
import {
  FormImmobiliareViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-immobiliare/view/form-immobiliare-view.component';
import {
  FormImmobiliareComponent
} from '../../../../lavoro/fascicoloFormShared/form-immobiliare/form-immobiliare.component';
import {
  FormMobiliareViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-mobiliare/view/form-mobiliare-view.component';
import {FormMobiliareComponent} from '../../../../lavoro/fascicoloFormShared/form-mobiliare/form-mobiliare.component';
import {FormCoterziComponent} from '../../../../lavoro/fascicoloFormShared/form-coterzi/form-coterzi.component';
import {
  FormCoterziViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-coterzi/view/form-coterzi-view.component';
import {
  FormPrecettoViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-precetto/view/form-precetto-view.component';
import {FormPrecettoComponent} from '../../../../lavoro/fascicoloFormShared/form-precetto/form-precetto.component';
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component';
import {
  FormRecuperoCreditiStragiudizialeComponent
} from '../../../../lavoro/fascicoloFormShared/form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component';
import {
  FormEsecuzioneViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-esecuzione/view/form-esecuzione-view.component';
import {
  FormEsecuzioneComponent
} from '../../../../lavoro/fascicoloFormShared/form-esecuzione/form-esecuzione.component';
import {
  FormRicorsoAmministrativoViewComponent
} from '../../../../lavoro/fascicoloFormShared/form-ricorso/view/form-ricorso-view.component';
import {
  FormRicorsoAmministrativoComponent
} from '../../../../lavoro/fascicoloFormShared/form-ricorso/form-ricorso.component';
import {FascicoloAmianto} from '../../../../lavoro/fascicoloFormShared/models/amianto/fascicolo-amianto';
import {
  FascicoloAmiantoGiudiziale
} from '../../../../lavoro/fascicoloFormShared/models/amianto-giudiziale/fascicolo-amianto-giudiziale';
import {FascicoloAppello} from '../../../../lavoro/fascicoloFormShared/models/appello/fascicolo-appello';
import {FascicoloArbitrato} from '../../../../lavoro/fascicoloFormShared/models/arbitrato/fascicolo-arbitrato';
import {
  FascicoloAzioneMonitoria
} from '../../../../lavoro/fascicoloFormShared/models/azione-monitoria/fascicolo-azione-monitoria';
import {
  FascicoloOpposizioneDecretoIngiuntivo
} from '../../../../lavoro/fascicoloFormShared/models/opposizione-decreto-ingiuntivo/fascicolo-opposizione-decreto-ingiuntivo';
import {
  FascicoloRicorsoCassazione
} from '../../../../lavoro/fascicoloFormShared/models/ricorso-cassazione/fascicolo-ricorso-cassazione';
import {
  FascicoloRicorsoLavoro
} from '../../../../lavoro/fascicoloFormShared/models/ricorso-lavoro/fascicolo-ricorso-lavoro';
import {
  FascicoloRicorsoOpposizione
} from '../../../../lavoro/fascicoloFormShared/models/ricorso-opposizione/fascicolo-ricorso-opposizione';
import {FascicoloCautelare} from '../../../../lavoro/fascicoloFormShared/models/cautelare/fascicolo-cautelare';
import {FascicoloCoTerzi} from '../../../../lavoro/fascicoloFormShared/models/coterzi/fascicolo-coterzi';
import {FascicoloImmobiliare} from '../../../../lavoro/fascicoloFormShared/models/immobiliare/fascicolo-immobiliare';
import {FascicoloMobiliare} from '../../../../lavoro/fascicoloFormShared/models/mobiliare/fascicolo-mobiliare';
import {FascicoloEsecuzione} from '../../../../lavoro/fascicoloFormShared/models/esecuzione/fascicolo-esecuzione';
import {FascicoloOrdinario} from '../../../../lavoro/fascicoloFormShared/models/ordinario/fascicolo-ordinario';
import {FascicoloPrecetto} from '../../../../lavoro/fascicoloFormShared/models/precetto/fascicolo-precetto';
import {
  FascicoloRecuperoCreditiStragiudiziale
} from '../../../../lavoro/fascicoloFormShared/models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale';
import {FascicoloSpeciale} from '../../../../lavoro/fascicoloFormShared/models/speciale/fascicolo-speciale';
import {
  FascicoloRicorsoAmministrativo
} from '../../../../lavoro/fascicoloFormShared/models/ricorso-amministrativo/fascicolo-ricorso-amministrativo';
import { FormNegoziazioneAssistitaViewComponent } from 'src/app/lavoro/fascicoloFormShared/form-negoziazione-assistita/view/form-negoziazione-assistita-view.component';
import { FormNegoziazioneAssistitaComponent } from 'src/app/lavoro/fascicoloFormShared/form-negoziazione-assistita/form-negoziazione-assistita.component';
import { FascicoloNegoziazioneAssistita } from 'src/app/lavoro/fascicoloFormShared/models/negoziazione-assistita/fascicolo-negoziazione-assistita';
import { FormGenericoComponent } from 'src/app/lavoro/fascicoloFormShared/form-generico/form-generico.component';
import { FormGenericoViewComponent } from 'src/app/lavoro/fascicoloFormShared/form-generico/view/form-generico-view.component';
import { FascicoloGenerico } from 'src/app/lavoro/fascicoloFormShared/models/generico/fascicolo-generico';


export function getComponentFromFormTenantLavoro(idFormTenant, view = false) {
  switch (idFormTenant) {
    case 'LavAmi_PRD': {
      return view ? FormAmiantoViewComponent : FormAmiantoComponent;
    }
    case 'LavAmg_PRD': {
      return view
        ? FormAmiantoGiudizialeViewComponent
        : FormAmiantoGiudizialeComponent;
    }
    case 'LavApp_PRD': {
      return view ? FormAppelloViewComponent : FormAppelloComponent;
    }
    case 'LavArb_PRD': {
      return view ? FormArbitratoViewComponent : FormArbitratoComponent;
    }
    case 'LavAzi_PRD': {
      return view
        ? FormAzioneMonitoriaViewComponent
        : FormAzioneMonitoriaComponent;
    }
    case 'LavOdi_PRD': {
      return view
        ? FormOpposizioneDecretoIngiuntivoViewComponent
        : FormOpposizioneDecretoIngiuntivoComponent;
    }
    case 'LavOpp_PRD': {
      return view
        ? FormOpposizioneDecretoIngiuntivoViewComponent
        : FormOpposizioneDecretoIngiuntivoComponent;
    }
    case 'LavRca_PRD': {
      return view
        ? FormRicorsoCassazioneViewComponent
        : FormRicorsoCassazioneComponent;
    }
    case 'LavRla_PRD': {
      return view
        ? FormRicorsoLavoroViewComponent
        : FormRicorsoLavoroComponent;
    }
    case 'LavRop_PRD': {
      return view
        ? FormRicorsoOpposizioneViewComponent
        : FormRicorsoOpposizioneComponent;
    }
    case 'LavRfo_PRD': {
      return view
        ? FormRitoForneroViewComponent
        : FormRitoForneroComponent;
    }
    case 'LavToc_PRD': {
      return view
        ? FormTentativoObbligatorioConciliazioneViewComponent
        : FormTentativoObbligatorioConciliazioneComponent;
    }
    case 'LavCau_PRD': {
      return view ? FormCautelareViewComponent : FormCautelareComponent; // "CAUTELARE";
    }
    case 'LavOrd_PRD': {
      return view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO";
    }
    case 'LavSpe_PRD': {
      return view ? FormSpecialeViewComponent : FormSpecialeComponent; // "SPECIALE";
    }
    case 'LavEim_PRD': {
      return view
        ? FormImmobiliareViewComponent
        : FormImmobiliareComponent; // "ESECUZIONE IMMOBILIARE";
    }
    case 'LavEmo_PRD': {
      return view ? FormMobiliareViewComponent : FormMobiliareComponent; // "ESECUZIONE MOBILIARE";
    }
    case 'LavEpt_PRD': {
      return view ? FormCoterziViewComponent : FormCoterziComponent; // "ESECUZIONE C/O TERZI";
    }
    case 'LavPre_PRD': {
      return view ? FormPrecettoViewComponent : FormPrecettoComponent; // "PRECETTO";
    }
    case 'LavRec_PRD': {
      return view
        ? FormRecuperoCreditiStragiudizialeViewComponent
        : FormRecuperoCreditiStragiudizialeComponent; // "RECUPERO CREDITI STRAGIUDIZIALE";
    }
    case 'LavPrev_PRD': {
      return view
        ? FormPrevidenzialeViewComponent
        : FormPrevidenzialeComponent;
    }
    case 'LavEse_PRD': {
      return view
        ? FormEsecuzioneViewComponent
        : FormEsecuzioneComponent;
    }
    case 'LavCon_PRD': {
      return view
        ? FormConciliazioneStragiudizialeViewComponent
        : FormConciliazioneStragiudizialeComponent;
    }
    case 'LavRam_PRD': {
      return view ? FormRicorsoAmministrativoViewComponent : FormRicorsoAmministrativoComponent; // "RICORSO AMMINISTRATIVO";
    }
    case 'LavNeg_PRD': {
      return view ? FormNegoziazioneAssistitaViewComponent : FormNegoziazioneAssistitaComponent;
    }
    case 'LavGen_PRD': {
      return view ? FormGenericoViewComponent : FormGenericoComponent;
    }
  }
}

export function getFascicoloLavoro(genericFascicolo): any {
  let fascicolo;
  switch (genericFascicolo) {
    case 'amianto': {
      fascicolo = new FascicoloAmianto();
      break;
    }
    case 'amiantogiudiziale': {
      fascicolo = new FascicoloAmiantoGiudiziale();
      break;
    }
    case 'appello': {
      fascicolo = new FascicoloAppello();
      break;
    }
    case 'arbitrato': {
      fascicolo = new FascicoloArbitrato();
      break;
    }
    case 'azionemonitoria': {
      fascicolo = new FascicoloAzioneMonitoria();
      break;
    }
    case 'opposizionedecretoingiuntivo': {
      fascicolo = new FascicoloOpposizioneDecretoIngiuntivo();
      break;
    }
    case 'ricorsocassazione': {
      fascicolo = new FascicoloRicorsoCassazione();
      break;
    }
    case 'opposizione': {
      fascicolo = new FascicoloOpposizioneDecretoIngiuntivo();
    }
    case 'ricorsolavoro':
    case 'ricorso': {
      fascicolo = new FascicoloRicorsoLavoro();
      break;
    }
    case 'ricorsoopposizione': {
      fascicolo = new FascicoloRicorsoOpposizione();
      break;
    }
    case 'ritofornero': {
      fascicolo = new FascicoloRitoFornero();
      break;
    }
    case 'tentativoobbligatorioconciliazione': {
      fascicolo = new FascicoloTentativoObbligatorioConciliazione();
      break;
    }
    case 'cautelare': {
      fascicolo = new FascicoloCautelare();
      break;
    }
    case 'esecuzionepressoterzi': {
      fascicolo = new FascicoloCoTerzi();
      break;
    }
    case 'esecuzioneimmobiliare': {
      fascicolo = new FascicoloImmobiliare();
      break;
    }
    case 'esecuzionemobiliare': {
      fascicolo = new FascicoloMobiliare();
      break;
    }
    case 'esecuzione': {
      fascicolo = new FascicoloEsecuzione();
      break;
    }
    case 'ordinario': {
      fascicolo = new FascicoloOrdinario();
      break;
    }
    case 'precetto': {
      fascicolo = new FascicoloPrecetto();
      break;
    }
    case 'recuperocreditistragiudiziale': {
      fascicolo = new FascicoloRecuperoCreditiStragiudiziale();
      break;
    }
    case 'previdenziale': {
      fascicolo = new FascicoloPrevidenziale();
      break;
    }
    case 'speciale': {
      fascicolo = new FascicoloSpeciale();
      break;
    }
    case 'conciliazione': {
      fascicolo = new FascicoloConciliazioneStragiudiziale();
      break;
    }
    case 'ricorsoamministrativo':
    case 'ricorsotar': {
      fascicolo = new FascicoloRicorsoAmministrativo();
      break;
    }
    case 'negoziazione': {
      fascicolo = new FascicoloNegoziazioneAssistita();
      break;
    }
    case 'genericogiudiziale': {
      fascicolo = new FascicoloGenerico();
      break;
    }
  }
  return fascicolo;
}
